var map = {
	"./commander.png": 1833,
	"./forme.png": 274,
	"./imprimante.png": 1834,
	"./menu.png": 1835,
	"./multipad.png": 1836,
	"./pause.png": 275,
	"./play.png": 519,
	"./power.png": 1837,
	"./service.png": 1838,
	"./table.png": 1839,
	"./timer.png": 1840,
	"./toque.png": 1841,
	"./valide.png": 273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1832;